import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import {HeaderSimple} from 'pages/Header/Content/pages/HeaderSimple';
import './style.sass';
import { PORTAL_URL } from 'constants/general';

export default function ServicioCliente() {
    const history = useHistory();

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Client Section Services');
        window.scrollTo(0, 0)
    }, [])

    const backHistory = () => {
        history.go(-1);
    };
    
    return (
        <>
            <HeaderSimple pageClass="hidden" />

            <div className="sectionTitleServicioClienteMenu">
                <button onClick={backHistory}>Servicio al cliente</button>
            </div>

            <div className="opcionesCliente">
                <ul className="listaExterna">
                    <Link to="/contacto" className="enlaces">
                        <li className="telefono"><span className="nombre">Contáctanos</span> <span className="icono"></span></li>
                    </Link>

                    <a href="http://facturacionelectronica.claroshop.com/" className="enlaces" target="_blank" rel="noopener noreferrer">
                        <li className="factura"><span className="nombre">Facturación</span> <span className="icono"></span></li>
                    </a>

                    <a href={PORTAL_URL + "/claroPromo/#forma-pago"} className="enlaces" rel="noopener noreferrer">
                        <li className="ofertas"><span className="nombre">Promociones Vigentes</span> <span className="icono"></span></li>
                    </a>

                    <li className="verified">
                        <span className="nombre">Políticas</span>
                    </li>
                    <ul className="listaInterna">
                        <Link to={"/politica-devoluciones/"} className="enlaces">
                            <li><span className="nombreI">Devoluciones</span><span className="icono"></span></li>
                        </Link>
                        <Link to={"/politica-reembolso/"} className="enlaces">
                            <li><span className="nombreI">Reembolso</span><span className="icono"></span></li>
                        </Link>

                        <Link to={"/politica-garantia/"} className="enlaces">
                            <li><span className="nombreI">Garantía </span><span className="icono"></span></li>
                        </Link>

                        <Link to={"/politica-recibo-telmex/"} className="enlaces">
                            <li><span className="nombreI">Recibo Telmex</span><span className="icono"></span></li>
                        </Link>
                    </ul>

                    <li className="balance"><span className="nombre">Términos legales</span> </li>
                    <ul className="listaInterna">
                        <Link to={"/aviso-privacidad/"} className="enlaces">
                            <li><span className="nombreI">Aviso de privacidad</span><span className="icono"></span></li>
                        </Link>

                        <Link to={"/terminos-y-condiciones/"} className="enlaces">
                            <li><span className="nombreI">Términos y condiciones</span><span className="icono"></span></li>
                        </Link>

                        <Link to={"/contrato-credito/"} className="enlaces">
                            <li><span className="nombreI">Contrato de crédito </span><span className="icono"></span></li>
                        </Link>
                    </ul>
                </ul>
            </div>
        </>
    )
}